export default {
  CLOSED: 3
}